<dacks-content>
  <div class="lg:mx-auto lg:w-[var(--mixed-content-card-container-width)] p-4 md:p-6">
    <dacks-content-header>
      @if ((searchResult$ | async); as searchResult) {
        <span>{{ searchResult.hits.length }}</span>
      }
      <span> {{ 'search-result.result_count' | translate }}</span>
    </dacks-content-header>
    <div class="w-full md:max-w-[80rem] pt-[0.4375rem] md:pt-4 lg:pt-8">
      <myupdates-search-slot [whiteFocus]="false"></myupdates-search-slot>
    </div>
    @if ((searchResult$ | async); as searchResult) {
      <div>
        @if (searchResult.hits.length > 0) {
          <div class="py-6">{{ 'search-result.sort_order' | translate }}</div>
        }
      </div>
      <div class="grid grid-cols-1 gap-4 md:max-w-[80rem]">
        @for (searchHit of searchResult.hits; track searchHit; let shnr = $index) {
          <div role="region"
               [attr.aria-label]="'Suchtreffer ' + (shnr +1)">
            <mat-card
              class="show-focus flex flex-col gap-2 justify-between pl-4 pr-3 max-h-fit md:max-h-80 py-4 relative">
              <div class="flex flex-row justify-between">
                <div class="flex flex-col">
                  <h2 class="mu-heading-5 text-[#0F0F0F] whitespace-normal">
                    <strong>{{ searchHit.title }}</strong>
                  </h2>
                  <div class="flex flex-col">
                    @if (searchHit.deliveryDate) {
                      <p class="text-[#8D8B8B] text-sm py-1 pr-[1.781rem]">
                        {{ 'product-change-details.contained_in_short' | translate }}
                        {{searchHit.deliveryDate | date:dateTranslation }}
                      </p>
                    }
                    <p class="search-result-card__hit-text text-[#8D8B8B] pr-[1.781rem]" [innerHTML]="searchHit.hitText">
                    </p>
                  </div>
                </div>
                <a class="no-underline outline-none self-center items-center" id="a_{{searchHit.id}}"
                   routerLink="/product-change/details/{{searchHit.id}}" aria-label="Mehr zum Suchtreffer"
                   tabindex="0">
                  <mat-icon class="text-petrol-800 mt-[0.625rem]" svgIcon="sli-pfeil-rechts-20"
                            aria-hidden="true"></mat-icon>
                  <span class="absolute inset-0 z-[2]"></span>
                </a>
              </div>
            </mat-card>
          </div>
        }
        @if (!(searchResult.hits.length > 0)) {
          <div class="mx-auto md:pl-0 pr-4 md:pr-0 mt-[5.75rem]">
            @if (isQueryTooShort) {
              <div>
                {{ 'search-result.query_too_short' | translate }}
              </div>
            } @else {
              <div>
                {{ 'search-result.no_hits_prefix' | translate }} "{{ searchTerm }}" {{ 'search-result.no_hits_postfix' | translate }}
              </div>
            }
          </div>
        }
      </div>
    } @else {
      <div class="pt-[5.75rem]">
        @if ((errorInfo$ | async); as errorInfo) {
          <myupdates-error-box class="error-box-white-style"
                               [errorTitle]="'search-result.error_search_result_title' | translate"
                               [errorText]="'search-result.error_search_result_text' | translate">
          </myupdates-error-box>
        } @else {
          <mat-spinner class="m-auto text-petrol-500"></mat-spinner>
        }
      </div>
    }
  </div>

  <footer-spacing type="content" />
</dacks-content>
